module.exports = __webpack_public_path__ + "static/about-img-b376e29cf4dea2bc31f8f3045396722c.jpg";